import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
// import classes from './Checkbox.module.scss';

type InputProps = {
  label: React.ReactNode;
  required?: boolean;
  defaultChecked?: boolean;
  checked?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

export default function CustomCheckbox({
  label,
  required = false,
  defaultChecked = false,
  checked,
  onChange,
}: InputProps) {
  return (
    <FormControlLabel
      control={
        <Checkbox
          sx={{ "&.Mui-checked": { color: "var(--green-color)" } }}
          defaultChecked={checked === undefined ? defaultChecked : undefined}
          checked={checked}
          onChange={onChange}
        />
      }
      required={required}
      label={label}
    />
  );
}
